import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { Wordmark } from "@/components/site/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    http.get("/auth/me").then(() => { if (alive) navigate("/admin/inbox", { replace: true }); }).catch(() => {});
    return () => { alive = false; };
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/login", { email, password });
      navigate("/admin/inbox");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-ink bg-grid px-5 text-bone">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="admin-back-home" className="mb-10 flex items-center gap-2 text-sm text-zinc-400 hover:text-bone"><ArrowLeft className="h-4 w-4" />grid-job.com</Link>
        <form onSubmit={submit} data-testid="admin-login-form" className="border border-white/10 bg-ink-2 p-8 sm:p-10">
          <Wordmark />
          <h1 className="mt-8 font-display text-3xl font-semibold tracking-tight">Staff sign-in</h1>
          <p className="mt-2 text-sm text-zinc-400">Private inbox for messages sent through the contact form.</p>
          <label className="mt-8 block"><span className="eyebrow">Email</span>
            <input data-testid="admin-email-input" type="email" autoComplete="username" className="field" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label className="mt-6 block"><span className="eyebrow">Password</span>
            <input data-testid="admin-password-input" type="password" autoComplete="current-password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          {error && <p data-testid="admin-login-error" role="alert" className="mt-5 text-sm text-red-400">{error}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-signal py-3.5 font-medium text-ink transition-opacity disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
